import { retry3Codes } from "@constants/Constants";
import { QueryClient } from "@tanstack/react-query";

export const CreateQueryClient = () => {
  return new QueryClient({
    defaultOptions: {
      queries: {
        retry: (failureCount: number, error: any) => {
          if ( retry3Codes.some(str => error.message.includes(str)) && failureCount < 3) {
            return true;
          }
          if (error.message.includes("Data cannot be null") && failureCount < 5) {
            return true;
          }
          return false;
        },
        retryDelay: (attemptIndex: number) => Math.min(1000 * 5 ** attemptIndex, 30000),
      },
    },
  });
};
